var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('div',{staticClass:"backdrop-content"},[_vm._v(_vm._s(_vm.$t('upload')))]),_c('div',{staticClass:"backdrop"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }